"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LIST_ID_STORE = "itemListId";
const setListId = (listId) => {
    try {
        window.sessionStorage.setItem(LIST_ID_STORE, listId);
    }
    catch (error) {
        console.error(error);
    }
};
const getListId = () => {
    let listId = null;
    try {
        listId = window.sessionStorage.getItem(LIST_ID_STORE);
    }
    catch (error) {
        console.error(error);
    }
    return listId;
};
const ITEM_LIST_STORE = "itemList";
const _getStoreFromLocalStorage = () => {
    var _a;
    let store = [];
    try {
        store = JSON.parse((_a = window.localStorage.getItem(ITEM_LIST_STORE)) !== null && _a !== void 0 ? _a : "[]");
    }
    catch (error) {
        console.error(error);
    }
    return store;
};
const _writeToLocalStorage = (store) => {
    try {
        const data = JSON.stringify(store);
        window.localStorage.setItem(ITEM_LIST_STORE, data);
    }
    catch (error) {
        console.error(error);
    }
};
const _saveItemInStore = (styleId, listId) => {
    const store = _getStoreFromLocalStorage();
    const data = { id: styleId, listId };
    const itemIndex = store.findIndex((item) => item.id === data.id);
    // add
    if (itemIndex === -1) {
        store.push(data);
    }
    // update
    else {
        store[itemIndex] = data;
    }
    _writeToLocalStorage(store);
};
const _removeItemsFromStore = (styleIds) => {
    const store = _getStoreFromLocalStorage();
    const newStore = [];
    store.forEach((item) => {
        if (!styleIds.includes(item.id))
            newStore.push(item);
    });
    _writeToLocalStorage(newStore);
};
const setItem = (styleId, listId) => {
    _saveItemInStore(styleId, listId);
};
const getItems = () => {
    const store = _getStoreFromLocalStorage();
    return store;
};
const removeItems = (styleIds) => {
    _removeItemsFromStore(styleIds);
};
const clear = () => {
    window.localStorage.removeItem(ITEM_LIST_STORE);
};
const GA4ItemListService = {
    setListId,
    getListId,
    setItem,
    getItems,
    removeItems,
    clear,
};
exports.default = GA4ItemListService;
